module.exports = __webpack_public_path__ + "fonts/Inter-700-latin-ext69.ad4eb06.woff2";